import { render, staticRenderFns } from "./ContractingPalace.vue?vue&type=template&id=074a1b0d&scoped=true&"
import script from "./ContractingPalace.vue?vue&type=script&lang=js&"
export * from "./ContractingPalace.vue?vue&type=script&lang=js&"
import style0 from "./ContractingPalace.vue?vue&type=style&index=0&id=074a1b0d&scoped=true&lang=css&"
import style1 from "./ContractingPalace.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a1b0d",
  null
  
)

export default component.exports